import React, { useState, useEffect, useCallback, useRef } from 'react';
import {Box, Typography, Grid, Button, Card, Link, Paper,IconButton } from '@mui/material';
import { BLUE_DARK, BLUE_LIGHT, BLUE_LIGHT_RGB_BORDER, BLUE_MAIN } from '../../theme/colors';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { useLocation } from 'react-router-dom';
import Search from '../../components/Search';
import { useWaiter } from '../../hooks/waiter/WaiterProvider';
import { delay } from '../../utilities/delay';
import CustomWaiter from '../../components/Waiter';
import { isMobile } from 'react-device-detect';
import { marketsList, marketsListSearch } from '../../hooks/actions/market';
import { LegacyMarket } from '../../models/market/LegacyMarket';
import MarketItem from '../../components/MarketsItems';
import { MarketGroupedByNationsForSearchResponse } from '../../models/responses/MarketGroupedByNationsForSearchResponse';

const MarketsList = () => {
    const {t} = useTranslationContext();
    const location = useLocation();
    const [url, setUrl] = useState<string>('');
    const [search, setSearch] = useState<string>('')
    const [listMarketsVip, setListMarketsVip] = useState<MarketGroupedByNationsForSearchResponse[]|undefined>();
    const [listMarkets, setListMarkets] = useState<MarketGroupedByNationsForSearchResponse[]|undefined>();
    const [searchWaiter, setSearchWaiter] = useState<boolean>(false)

    const {setWaiterView} = useWaiter();

    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(()=>{ // carico i markets che hanno un 
        setWaiterView(true);
        marketsList().then((resp) => {
            //setListMarketsVip(resp);
            setListMarkets(resp);
            
            delay(500).then(()=>{
                setWaiterView(false);
            })
        }).catch(e=>{
            console.log(e)
            delay(500).then(()=>{
                setWaiterView(false);
            })
        })
    },[])

    useEffect(()=>{
        setUrl(`${window.location.protocol}//${window.location.host}${location.pathname}${location.search}`)
    },[location])
    
    useEffect(() => {
        if (!search || search.length === 0) {
            setWaiterView(true);
            marketsList().then((resp) => {
                setListMarkets(resp);
                delay(500).then(() => {
                    setWaiterView(false);
                });
            }).catch(e => {
                console.log(e);
                delay(500).then(() => {
                    setWaiterView(false);
                });
            });
        }
    }, [search]);

    useEffect(()=>{
        if(search.length >= 2) {
            setSearchWaiter(true)
        }else{
            setSearchWaiter(false)
            setListMarkets(undefined)
        }
            
        const performSearch = async () => {
            try {
                if (debounceTimeout.current) clearTimeout(debounceTimeout.current);
                const minChars = 2;
                let respSearch;
                
                debounceTimeout.current = setTimeout(async () => {
                    if (search.length >= minChars) {
                        respSearch = await marketsListSearch(search);
                        setListMarkets(respSearch);
                        debounceTimeout.current = null;
                        setSearchWaiter(false)
                    }
                }, 1200);
            } catch (e) {
                console.log(e);
                setSearchWaiter(false)
            }
        };

        performSearch();
    },[search])

    const handleInput = async (input: string) => {
        const newString = input;
        if(newString === search) return; 

        if(newString.length > 20) return;

        setSearch(newString);
    }

    return(
        <Box sx={{
            width:'100%', 
            display:'flex', 
            justifyContent:'center',
            flexDirection:'column',
        }}>
            {/* Search */}
            <Grid container spacing={0}  justifyContent={{ xs: 'center', sm: 'flex-end' }} paddingBottom={4}>
                <Grid item xs={!isMobile ? 10 : 12} sm={6} md={4} display={'flex'}> 
                    <Search 
                        handleInput={handleInput}
                        search={search}
                        setSearch={setSearch}
                        palceHolder='Cerca per Prodotto, Fornitore, Città..'
                    />
                    
                    <div style={{
                        paddingTop:'3px',
                        paddingLeft:'3px',
                        width:'50px',
                        height:'35px'
                    }}>
                        {searchWaiter && <CustomWaiter size={30} width={40}/>}
                    </div>
                </Grid>
            </Grid>

            {/* Lista dei markets */}

            {
                listMarkets && listMarkets.length > 0 ? (
                    listMarkets.map((entity, index) => (
                    <Grid container spacing={4} justifyContent="flex-start" key={index}>
                        {
                            entity.markets.map((item, subindex)=>(
                                <Grid item xs={12} sm={6} md={4} key={subindex}>
                                    <MarketItem // SOSTITUIRE QUESTO CON GLI ITEM DEL MARKET
                                        name={item.marketName} 
                                        nation={item.marketState}
                                        mail={item.marketMail}
                                        website={item.marketWebSite} 
                                        phone={item.marketTelephone}
                                        city={item.marketCity}
                                        province={item.marketProvince}
                                        type={item.marketType}
                                        typeActivity={item.marketTypeActivity}
                                        description={item.description}
                                        tags={item.tags}
                                        address={item.marketAddress}
                                        cap={item.marketCAP}
                                    />
                                </Grid>
                            ))
                        }
                    </Grid>
                ))
                ):(
                    listMarkets !== undefined && <Grid item xs={12} 
                        sx={{
                            display:'flex',
                            justifyContent:'center',
                            padding:'100px 0 10px 0',
                        }}
                    >
                        <Typography variant='body1'>{
                            search.length >= 2 && 
                            t("Non ci sono elementi da visualizzare.")
                        }</Typography>
                    </Grid>   
                )
            }
        </Box>
    )
}

export default MarketsList;